import {
  SPOR_TOTO_TOGGLE_SELECTION,
  SPOR_TOTO_REMOVE_SELECTIONS,
  SPOR_TOTO_RANDOM_SELECTIONS,
  SPOR_TOTO_GET_POPULAR_SELECTIONS,
  SPOR_TOTO_SET_SELECTIONS
} from 'Store/constants';

const initialState = {
  columnA: [],
  columnB: [],
  columnC: [],
  columnD: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SPOR_TOTO_TOGGLE_SELECTION:
    {
      const { columnName, id, oddType, index } = action.payload;
      let newColumn = [...state[columnName]];

      if (!newColumn[index] || (newColumn[index] && !newColumn[index].odds)) {
        newColumn[index] = { eventId: id, odds: [oddType] };
      } else {
        if (!newColumn[index].odds.includes(oddType)) {
          newColumn[index] = { eventId: id, odds: [...newColumn[index].odds, oddType] };
        } else {
          newColumn[index] = { eventId: id, odds: newColumn[index].odds.filter(odd => odd !== oddType) };
        }
      }

      if (!newColumn.some(event => event?.odds && event.odds.length)) {
        newColumn = [];
      }

      return { ...state, [columnName]: newColumn };
    }

    case SPOR_TOTO_REMOVE_SELECTIONS:
      return action.payload === 'all' ? {
        columnA: [],
        columnB: [],
        columnC: [],
        columnD: []
      } : { ...state, [action.payload]: [] };

    case SPOR_TOTO_SET_SELECTIONS:
      return {
        ...state,
        ...action.payload.selections,
      };
  

    case SPOR_TOTO_RANDOM_SELECTIONS:
    {
      let newColumnValues = [];
      action.payload.events.eventsData.events.gameCycleEntityModel.eventVOs.forEach(sporTotoEvent => {
        let randomValue = Math.floor(Math.random() * 3);
        newColumnValues.push({
          eventId: sporTotoEvent.id,
          odds: [randomValue.toString()]
        });
      });
      return { ...state, [action.payload.columnName]: newColumnValues };
    }

    case SPOR_TOTO_GET_POPULAR_SELECTIONS:
      return { ...state, [action.payload.columnName]: action.payload.selections };

    default:
      return state;
  }
};
